import { useMemo } from 'react'

const BASE_URL = 'http://ai-test.beta3x.com'

interface FilePreviewProps {
  fileUrl: string
}

const FilePreview: React.FC<FilePreviewProps> = ({ fileUrl }) => {
  // 构建预览 URL
  const previewUrl = useMemo(() => {
    if (!fileUrl) return ''
    // 拼接完整的文件 URL
    const fullFileUrl = fileUrl.startsWith('http')
      ? fileUrl
      : `${BASE_URL}${fileUrl}`
    // 对文件 URL 进行编码
    const encodedFileUrl = encodeURIComponent(fullFileUrl)
    return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedFileUrl}`
  }, [fileUrl])

  if (!fileUrl) {
    return (
      <div className="w-full h-full flex items-center justify-center text-gray-500">
        <div className="text-center">
          <div className="text-lg mb-2">📄</div>
          <div>请选择要预览的文件</div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full h-full">
      <iframe
        src={previewUrl}
        className="w-full h-full border-0 -translate-x-1 -translate-y-1"
        title="文档预览"
        sandbox="allow-scripts allow-same-origin allow-forms"
      />
    </div>
  )
}

export default FilePreview
